import React, { useState, useEffect } from 'react';

function UpdatePrompt() {
  const [showUpdate, setShowUpdate] = useState(false);
  const [waitingWorker, setWaitingWorker] = useState(null);

  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.ready.then(registration => {
        // Vérifier si une mise à jour est en attente au chargement
        if (registration.waiting) {
          setWaitingWorker(registration.waiting);
          setShowUpdate(true);
        }

        // Écouter les nouvelles mises à jour
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                setWaitingWorker(newWorker);
                setShowUpdate(true);
              }
            });
          }
        });
      });

      // Recharger la page quand le nouveau SW prend le contrôle
      let refreshing = false;
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (!refreshing) {
          refreshing = true;
          window.location.reload();
        }
      });
    }
  }, []);

  const handleUpdate = () => {
    if (waitingWorker) {
      waitingWorker.postMessage({ type: 'SKIP_WAITING' });
    }
  };

  if (!showUpdate) return null;

  return (
    <div className="fixed top-0 left-0 right-0 bg-primary-600 text-white p-3 z-50 shadow-lg">
      <div className="max-w-md mx-auto flex items-center justify-between">
        <span className="text-sm">Nouvelle version disponible</span>
        <button
          onClick={handleUpdate}
          className="bg-white text-primary-600 px-4 py-1 rounded-full text-sm font-medium hover:bg-primary-50"
        >
          Mettre à jour
        </button>
      </div>
    </div>
  );
}

export default UpdatePrompt;
